export const bracketAccessories = [
    'GHB-30',
    'GHB-40',
    'GPB-30',
    'GPB-40',
];

export const wallAccessories = [
    'GPS-60',
    'GPS-90',
    'GHS-60',
    'GHS-90',
];
